import { Box } from "@mantine/core";
import type { LLMConfigOptionsViewModel } from "@models/doctype";
import { llmConfigSections, OptionSections } from "./RuntimeOptions";

interface RuntimeConfigOptionsFieldsProps {
    /** Scopes the options: input options exist on DATA_EXTRACTION only. */
    stepType: string;
    value: LLMConfigOptionsViewModel | null;
    onChange: (value: LLMConfigOptionsViewModel | null) => void;
    onDirty?: () => void;
}

export const RuntimeConfigOptionsFields = ({
    stepType,
    value,
    onChange,
    onDirty,
}: RuntimeConfigOptionsFieldsProps) => (
    <Box mt="lg">
        <OptionSections
            sections={llmConfigSections(stepType)}
            value={value}
            onChange={(next) => {
                onChange(next);
                onDirty?.();
            }}
        />
    </Box>
);
